module.exports = __webpack_public_path__ + "img/user.dbfd82ae.jpeg";